<ng-container *ngIf="errorMsg; else resultTpl">
  <nz-result
    nzStatus="error"
    nzTitle="Teamcenter gave an error"
    [nzSubTitle]="errorMsg"
  ></nz-result>
</ng-container>

<ng-template #resultTpl>
  <nz-table
    #infoCodesTable
    [nzData]="data"
    [nzLoading]="loading"
    nzSize="small"
    nzShowPagination="false"
  >
    <thead>
      <tr>
        <th>Material number</th>
        <th>Code group</th>
        <th>Activity code</th>
        <th>Activity code text</th>
        <th>Activity text</th>
        <th>Created by</th>
        <th>Created on</th>
        <th>Long text</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of infoCodesTable.data; trackBy: trackByRef">
        <tr>
          <td>{{ item.materialNumber }}</td>
          <td>{{ item.codeGroup }}</td>
          <td>{{ item.activityCode }}</td>
          <td>{{ item.activityCodeText }}</td>
          <td>{{ item.activityText }}</td>
          <td>{{ item.createdBy }}</td>
          <td>{{ item.createdOn | date: 'shortDate' }}</td>
          <td>
            <button
              *ngIf="item.longTextAvailable"
              (click)="onLongTextClicked(item)"
              nz-button
              nzType="default"
              nzShape="circle"
            >
              <i nz-icon nzType="file-text" nzTheme="outline"></i>
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</ng-template>
